import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GetCurrenciesService } from './get-currencies/get-currencies.service';

@NgModule({
  imports: [CommonModule],
  providers: [
    GetCurrenciesService
  ],
})
export class CurrenciesModule {}
